import React from 'react';
import questionareStyle from '../../style';
import YesNo from '../YesNo';

export default function Slide3(props){
    let style = questionareStyle();

    return(
        <div>
            <p
             style={{
                ...{
                    marginTop: '1rem'
                },
                ...style.questionareText()
             }}
            >
                Would you like some cardiovascular (cardio) training involved in your workouts?
            </p>
            <YesNo 
                nextPressed = {(answer) => {
                    props.nextPressed({
                        a3: answer
                    });
                }}
            />
        </div>
    );
}